import React, { type FC } from "react";

import { type ComponentProps } from "~/types/components";

type FilterSectionRangeInputProps = ComponentProps & {
  options: {
    label: string;
    key: string;
    checked: boolean;
  }[];
  handleChange: (key: string) => void;
};

type FilterSectionRangeOutputProps = Omit<
  FilterSectionRangeInputProps,
  "options"
> & {
  options: {
    label: string;
    value: string;
    checked: boolean;
  }[];
};

export const withFilterSectionRange =
  (Component: FC<FilterSectionRangeOutputProps>) =>
  ({
    name = "FilterRange",
    handleChange,
    ...rest
  }: FilterSectionRangeInputProps) => {
    const mappedOptions = rest.options.map(({ label, key, checked }) => ({
      value: key,
      label: label,
      checked,
    }));

    Component.displayName = name;
    return <Component options={mappedOptions} handleChange={handleChange} />;
  };
